"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResult = void 0;
const isResult = function (value) {
    return typeof value === 'object' && value !== null &&
        Object.keys(value).length === 6 &&
        ('error' in value || 'value' in value) &&
        'hasError' in value && typeof value.hasError === 'function' &&
        'hasValue' in value && typeof value.hasValue === 'function' &&
        'unwrapOrThrow' in value && typeof value.unwrapOrThrow === 'function' &&
        'unwrapOrElse' in value && typeof value.unwrapOrElse === 'function' &&
        'unwrapOrDefault' in value && typeof value.unwrapOrDefault === 'function';
};
exports.isResult = isResult;
